import React from "react";
import { TFunction } from "i18next";
import { toast, ToastOptions } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";

import { store } from "../../../../../redux/store";
import { setIsLoading } from "../../../../../redux/slices/fidelitySlice";

type Params = {
    associated: FidelityRow[];
    dataFidelity: FidelityRow;
    userID: number;
    franchiseID: string;
    operatorID: string;
    uuidUser: string | null;
    fetchGlobal: FetchGlobal;
    t: TFunction;
};

export async function editFidelityForAllShops(params: Params) {
    const {
        associated,
        dataFidelity,
        userID,
        franchiseID,
        operatorID,
        uuidUser,
        fetchGlobal,
        t,
    } = params;

    store.dispatch(setIsLoading(true));
    toast.dismiss();

    const objectData: Record<string, FidelityPayload> = {};
    const shopIds: string[] = [];

    for (const el of associated) {
        shopIds.push(el.shopId as string);
        objectData[el.Id] = {
            designation: dataFidelity.data[el.Id].designation,
            type: dataFidelity.data[el.Id].type,
            number_fidelity_points: el.number_fidelity_points,
            money_correspondence: el.money_correspondence,
            devise: el.devise,
            pays: el.pays,
            authentication_mode: el.authentication_mode,
            sortedVisibility: el.sortedVisibility,
            Login: el.Login,
            password: el[t("Password")],
            note: dataFidelity.data[el.Id].note,
            isActive: el.isActive,
            isArchived: el.isArchived,
            shopId: el.shopId as string,
            dashboardLink: el[t("Dashboard Link")],
            user: el.user,
            apiKey: el["API key"],
            auresKonnectGroup: el.auresKonnectGroup,
            isCentralizationActive: el.isCentralizationActive,
            isVisibiliteActive: el.isVisibiliteActive,
            fidelityChoiceIndex: el.fidelityChoiceIndex,
        };
    }

    const body = {
        userId: userID,
        shopId: shopIds,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser,
        data: objectData,
        isShop: true,
        isAssociate: true,
    };

    try {
        const result = (await fetchGlobal(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            }
        )) as { error: boolean };
        if (result.error === false) {
            toast.success(t("The fidelity of shop  was successfully changed"), {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            } as ToastOptions);
        }
    } catch (e) {
        toast.error(t("There's an error"), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    } finally {
        store.dispatch(setIsLoading(false));
    }
}
